export default "__VITE_ASSET__C35JrI1T__"